// console.log('Loading fr.js ...');

require("../vendor/bootstrap/bootstrap-datepicker/locales/bootstrap-datepicker.fr.min");
require("../lang/lang-fr");



// WEBPACK FOOTER //
// ./entries/fr.js